import { render, staticRenderFns } from "./dcPxVideoList.vue?vue&type=template&id=5d53e074&scoped=true&"
import script from "./dcPxVideoList.vue?vue&type=script&lang=js&"
export * from "./dcPxVideoList.vue?vue&type=script&lang=js&"
import style0 from "./dcPxVideoList.vue?vue&type=style&index=0&id=5d53e074&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d53e074",
  null
  
)

export default component.exports